import { render } from "./MultiCheckbox.vue?vue&type=template&id=fb58662a&scoped=true"
import script from "./MultiCheckbox.vue?vue&type=script&lang=js"
export * from "./MultiCheckbox.vue?vue&type=script&lang=js"

import "./MultiCheckbox.vue?vue&type=style&index=0&id=fb58662a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb58662a"]])

export default __exports__